import { I18NString } from "../../features/common"
import { IMapObjType } from "../../features/mapObjectType"
import { ISelectedMapObjectTypes, setAllCheckStatus } from "../../features/selectedObjectType"
import { useMapObjectTypesQuery } from "../../services/MapClientAPI"
import { printMultilangString } from "../../services/utils"
import { useDispatch } from "react-redux"

export interface IMapMarkerFilterMassOpProps
{
    activeLang: string
}

const MapMarkerFilterMassOp = ({activeLang}:IMapMarkerFilterMassOpProps) =>{

    const dispatch = useDispatch()
    const {data, /*error,*/ /*isLoading*/} = useMapObjectTypesQuery()

    var selectAll:I18NString = {
            ru: "Выбрать все",
            en: "Show all"
        }  
     var desselectAll:I18NString = {
            ru: "Снять все",
            en: "Hide all"
        }
    var none_types_ids:number[] = []
    var all_type_ids:number[] = [];
    if(data) all_type_ids= data?.map((item:IMapObjType)=> {return item.id});   

    return (<div className="interactive-map__menu--marker_op">
        <p onClick={() => dispatch(setAllCheckStatus(none_types_ids))}>{printMultilangString(selectAll, activeLang)}</p>
        <p onClick={() => dispatch(setAllCheckStatus(all_type_ids))}>{printMultilangString(desselectAll, activeLang)}</p>
    </div>)
}


export default MapMarkerFilterMassOp